const FORM_KEYS = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  language: 'language',
  topics: 'topics',
  format: 'format',
  assessmentTypes: 'assessmentTypes',
  specificStandard: 'specificStandards',
  curriculum: 'curriculum',
  strategies: 'strategies',
  curriculumFramework: 'curriculumFramework',
};

export default FORM_KEYS;
